import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=4032e677"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=4032e677&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports